export default {
  Info: {
    Title: 'In-home care for every person, every day, and every need',
    Book: 'Need assistance? <a target="_blank" rel="noopener noreferrer" href="https://calendly.com/daniel-carequilt/care-plan-call-with-daniel">Book a demo.</a>',
  },
  WelcomeScreen: {
    BrandName: 'CareQuilt',
    WelcomeBack: 'Welcome back.',
    MainTagline: 'Your care starts here.',
    Subtitle: 'Your care circle lives here. Sign in to stay connected and supported.',
    Privacy: {
      Title: 'Your privacy is protected.',
      Description: 'We use secure encryption to keep your information safe and private.',
    },
  },
  Signup: {
    Welcome: 'Welcome back.',
    Signin: 'Sign In',
    WorkspaceForm: {
      Workspace: 'Workspace name',
      Login: 'Continue',
      HaveAccount: 'Need an account? ',
      GetStarted: 'Get started',
      NoOrg: 'This workspace is not valid',
    },
    UserAuth: {
      Email: 'Email',
      Password: 'Password',
      Login: 'Sign in',
      LoginWith: 'Sign In With',
      ForgotPassword: {
        Create: 'Forgot password? ',
        GetStarted: 'Click here',
      },
      Errors: {
        Email: 'Email must be valid.',
      },
      ResetPassword: {
        Title: 'Create new password',
        Body: 'We\'ll ask for this password whenever you sign-in',
        Password: 'New Password',
        RePassword: 'Re-enter Password',
        Action: 'Save change and sign-in',
        Errors: {
          Length: 'Password must be at least 6 characters',
          Match: 'Passwords must match',
        },
      },
    },
    ForgotPassword: {
      Link: 'Forgot password?',
      FirstStage: {
        Title: 'Forgot password?',
        Body: 'Enter the email address associated with your account.',
        Email: 'Email',
        Action: 'Continue',
        Fail: 'Could not reset your password at this time. Please try again.',
      },
      SecondStage: {
        Title: 'Verification required',
        Body: 'To continue, complete this verification step. We\'ve sent a One Time Password (OTP) to your email. Please enter it below.',
        OTP: 'OTP',
        Action: 'Continue',
      },
      ThirdStage: {
        Title: 'Create new password',
        Body: 'We\'ll ask for this password whenever you sign-in',
        Password: 'New Password',
        RePassword: 'Re-enter Password',
        Action: 'Save change and sign-in',
      },
      Errors: {
        Email: 'Enter a valid email',
        OTP: 'Enter a valid OTP',
        Password: {
          Length: 'Password must be at least 6 characters',
          Match: 'Passwords must match',
        },
      },
      GoBack: {
        GoBack: 'Go back',
        LoginScreen: 'to the login screen',
      },
    },
  },
  MagicLink: {
    Sent: 'Sign-in link sent to your email! ',
    SentSubtitle: 'Please check your inbox.',
    SendFailed: 'Sorry, we failed to send you a sign-in link. Please try again.',

    LoggingIn: 'Sign-in link received!',
    LoggingInSubtitle: 'Signing you in, please wait a moment...',
    LoginFailed: 'We could not sign you in.',
    LoginFailedSubtitle: 'The link might be expired or invalid.',
    LoginFailedLink: 'Please try again',
  },
  OtpBox: {
    Title: 'Enter one-time password',
    Description: 'To continue, please enter the six-character code that we sent to',
    SubmitButton: 'Verify',
    ResendButton: 'Resend Code',
    ChangeEmailPrompt: 'Entered the wrong email?',
    ChangeEmailLink: 'Change email',
  },
  EmailBox: {
    EmailTitle: 'Enter your email',
    PasswordTitle: 'Enter your password',
    EmailDescription: 'Please enter your registered email to log in',
    PasswordDescription: 'Please enter your password to log in',
    SubmitButton: 'Verify',
    LinkPrompt: 'Can\'t remember your registered email?',
    LinkText: 'Get support',
  },
  NotAuthorizedException: 'Incorrect username or password.',
  federatedLoginFail: 'Sorry, we failed to sign you in. Please try again.',
};
